import { render, staticRenderFns } from "./Documentale.vue?vue&type=template&id=49876722&scoped=true&"
import script from "./Documentale.vue?vue&type=script&lang=js&"
export * from "./Documentale.vue?vue&type=script&lang=js&"
import style0 from "./Documentale.vue?vue&type=style&index=0&id=49876722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49876722",
  null
  
)

export default component.exports